<template>
    <v-navigation-drawer
        v-model="drawer"
        :color="color"
        :expand-on-hover="expandOnHover"
        :mini-variant="miniVariant"
        :permanent="permanent"
        app
        dark
      >
        <v-list
          dense
          nav
          class="py-0"
        >
          <v-list-item two-line :class="miniVariant && 'px-0'">
            <v-list-item-avatar>
              <img :src="logo">
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>ระบบนัดหมาย</v-list-item-title>
              <v-list-item-subtitle></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item-group v-model="drawer_item">
            <v-list-item
              v-for="(item,i) in items"
              :key="`menu-${i}`"
              :value="item.value"
              :to="{ name: item.name }"
              link
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
    </v-navigation-drawer>
</template>


<script>

  import Staff from '@/model/instance/Staff.js'
  import config from '../../config.js'

  export default {
    props: ['current_item','mini'],
    data () {
      return {
        drawer_item : this.current_item,
        drawer: true,
        items: Staff.getMenuList(),
        color: 'primary',
        permanent: false,
        miniVariant: this.mini == undefined ? false : this.mini,
        expandOnHover: this.mini == undefined ? false : this.mini,
        background: false,
        logo : config.logo,
      }
    }
  }
 
</script>